import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getBestTimes, getUserInfo } from './api';
import GameConfigContext from './contexts/GameConfigContext/GameConfigContext';
import useGameConfig from './contexts/GameConfigContext/useGameConfig';
import ConfigContext from './contexts/ConfigContext/ConfigContext';
import useConfig from './contexts/ConfigContext/useConfig';
import Game from './components/Game/Game';
import CircularProgress from '@mui/material/CircularProgress';
import ChooseGame from './components/ChooseGame/ChooseGame';
import { transitions, positions, Provider as AlertProvider, AlertComponentPropsWithStyle } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import { scaleUsersTimes } from './components/ChooseGame/functions';

const options = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: '30px',
  // you can also just use 'scale'
  transition: transitions.SCALE
}


const AppBox = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 772px;
  height: 528px;
  overflow: hidden;
  background: #000;
`;

declare global {
  interface External {
    notify: (val: string) => void
  }
}

declare global {
  interface Window {
    ReactNativeWebView: {
      postMessage: (str: string) => void;
    };
    isMouseDown: boolean;
    userId: string;
  }
}

const App = (): JSX.Element => {
  const gameConfig = useGameConfig();
  const config = useConfig();
  const [loading, setLoading] = useState(true);
  const [windowsId, setWindowsId] = useState('');

  useEffect(() => {
    if (windowsId.length > 0) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
      (async function() {
        try {
          const userData = await getUserInfo(windowsId);
          const bestT = await getBestTimes('all');
          console.log('App.tsx reload');
          bestT.best1 = scaleUsersTimes(bestT.best1);
          bestT.best2 = scaleUsersTimes(bestT.best2);
          bestT.best3 = scaleUsersTimes(bestT.best3);
          config.setConfig({...config.config, user: {...config.config.user, bestTimes: bestT, name: userData.name, id: userData.id, windowsId, country: userData.country, lastGames: userData.lastGames, best1: userData.best1, best2: userData.best2, best3: userData.best3 }});
          setLoading(false);
        } catch (e) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          // document.body.innerHTML = e;
          console.log(e);
        }
      })();
    }
  }, [config.config.reload]);

  useEffect(() => {
    if (windowsId.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      (async function() {
        try {
          const tile = document.createElement('img');
          tile.src = "images/closed.svg";
          const tile0 = document.createElement('img');
          tile0.src = "images/type0.svg";
          const tile1 = document.createElement('img');
          tile1.src = "images/type1.svg";
          const tile2 = document.createElement('img');
          tile2.src = "images/type2.svg";
          const tile3 = document.createElement('img');
          tile3.src = "images/type3.svg";
          const tile4 = document.createElement('img');
          tile4.src = "images/type4.svg";
          const tile5 = document.createElement('img');
          tile5.src = "images/type5.svg";
          const userData = await getUserInfo(windowsId);
          config.setConfig({...config.config, user: {...config.config.user, name: userData.name, id: userData.id, windowsId, country: userData.country, lastGames: userData.lastGames, best1: userData.best1, best2: userData.best2, best3: userData.best3 }});
          setLoading(false);
        } catch (e) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          // document.body.innerHTML = e;
          console.log(e);
        }
      })();
    }
  }, [windowsId]);

  useEffect(() => {
    if (window.ReactNativeWebView)
      window.ReactNativeWebView.postMessage('getUserId');
    const interval = setInterval(() => {
      window.userId = window.userId ? window.userId : 'test123';
      if (window.userId) {
        setWindowsId(window.userId);
        clearInterval(interval);
        // (function(d,z,s){s.src='//'+d+'/400/'+z.toString();try{(document.body||document.documentElement).appendChild(s)}catch(e){console.log(e)}})('besmeargleor.com',4727830,document.createElement('script'));
      }
    }, 500)
  }, [])

  return (
    <AlertProvider template={AlertTemplate as React.ComponentType<AlertComponentPropsWithStyle>} {...options}>
      <ConfigContext.Provider value={config}>
        <GameConfigContext.Provider value={gameConfig}>
          {loading ? (
            <AppBox>
              <CircularProgress />
            </AppBox>) : (<AppBox>
            <div style={{display: config.config.openGameChooser ? 'block' : 'none'}}>
              <ChooseGame />
            </div>
            <Game />
          </AppBox>)}
        </GameConfigContext.Provider>
      </ConfigContext.Provider>
    </AlertProvider>
  );
};

export default App;
